<template>
  <v-dialog v-model="dialog" max-width="400px">
    <v-card rounded="lg">
      <v-card-title> Vincular POS por Número de Série </v-card-title>
      <v-card-text>
        <pos-search v-model="session"></pos-search>
      </v-card-text>
      <v-card-actions class="justify-space-between">
        <v-btn text @click="dialog = false">cancelar</v-btn>
        <v-btn color="primary" @click="connect" :disabled="!session">
          Continuar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

import POS from "@/services/admin/pos";
import PosSearch from "./PosSearch.vue";

export default {
  name: "FindPosSessionBySN",
  components: { PosSearch },
  data: () => ({
    dialog: false,
    session: null,
  }),
  methods: {
    open() {
      this.dialog = true;
      this.session = null;
    },
    connect() {
      this.dialog = false;
      this.$emit("success", this.session);
    },
  },
  mounted() {
    this.$root.$on("find-pos-session-by-sn", this.open);
  },
};
</script>

<style></style>
